// "Keep scrolling" hint on the Why bamboo page (sections/sivana-bamboo-story.liquid, .sbs-cue).
// Appears only after the shopper has stopped scrolling for 3 seconds, and only where scrolling still
// has something to show: near the top of the page, or inside a pinned scene ([data-sbs-pinned]) that
// holds the screen still while scrolling plays it, before its last stretch. Hides the moment they
// scroll again.
const cue = document.querySelector('[data-sbs-cue]');
const scenes = [...document.querySelectorAll('[data-sbs-pinned]')];
const IDLE_MS = 3000;

if (cue) {
  let timer = 0;

  const worthShowing = () => {
    const vh = window.innerHeight;
    if (window.scrollY < 40) return true;
    return scenes.some((scene) => {
      const r = scene.getBoundingClientRect();
      return r.top <= vh * 0.05 && r.bottom > vh * 1.6;
    });
  };

  const wait = () => {
    clearTimeout(timer);
    timer = setTimeout(() => cue.classList.toggle('is-on', worthShowing()), IDLE_MS);
  };

  const onScroll = () => {
    cue.classList.remove('is-on');
    wait();
  };

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  wait();
}
